import React, { lazy } from 'react';
import { FileText, Zap, GraduationCap, BookOpen, ShieldCheck, Lock, Package, Star, MapPin } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-20 pb-24 px-6 lg:px-8 bg-gradient-to-b from-lavender to-lightblue" data-id="element-104">
      <div className="max-w-[1100px] mx-auto text-center" data-id="element-105">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight text-dark mb-6 leading-tight" data-id="element-106">
          Aprobá tu próximo parcial en menos de una semana, sin importar cuánto
          tiempo te queda
        </h1>

        <div className="flex justify-center mb-8" data-id="element-107">
          <img src="https://cdn.magicpatterns.com/uploads/9E9MQHn95xFXnhPdVcDnMd/Gemini_Generated_Image_c8mxxmc8mxxmc8mx.png" alt="Aprobá en serio Mockup" className="w-[85%] max-w-[640px] md:max-w-[760px] h-auto object-contain drop-shadow-xl rounded-xl" loading="lazy" data-id="element-108" />
        </div>

        <p className="text-lg md:text-xl text-dark/80 max-w-3xl mx-auto mb-8 font-medium" data-id="element-109">
          La guía completa para estudiar bajo presión, gestionar el estrés y
          rendir bien en cualquier examen. Sin importar la carrera.
        </p>

        <div className="flex flex-wrap justify-center gap-3 mb-10" data-id="element-110">
          <Badge icon={<FileText size={16} data-id="element-112" />} text="PDF Digital" data-id="element-111" />
          <Badge icon={<Zap size={16} data-id="element-114" />} text="Acceso Inmediato" data-id="element-113" />
          <Badge icon={<GraduationCap size={16} data-id="element-116" />} text="Cualquier carrera" data-id="element-115" />
          <Badge icon={<BookOpen size={16} data-id="element-118" />} text="+160 páginas" data-id="element-117" />
        </div>

        <button onClick={() => document.getElementById('precios')?.scrollIntoView({
        behavior: 'smooth'
      })} className="bg-salmon hover:bg-salmon/90 text-dark font-bold text-xl md:text-2xl py-5 px-8 md:px-12 rounded-full shadow-lg transform transition hover:scale-105 mb-4 w-full md:w-auto" data-id="element-119">
          💥 QUIERO APROBAR EN SERIO AHORA
        </button>

        <p className="text-sm text-dark/70 mb-8 font-medium" data-id="element-120">
          Garantía 7 días · Pago seguro · Mercado Pago · Acceso en 5 minutos
        </p>

        <div className="flex flex-wrap justify-center gap-4 text-sm font-semibold text-dark/80" data-id="element-121">
          <TrustBadge icon={<ShieldCheck size={18} className="text-green-600" data-id="element-123" />} text="Garantía 7 días" data-id="element-122" />
          <TrustBadge icon={<Lock size={18} className="text-gray-600" data-id="element-125" />} text="Pago seguro" data-id="element-124" />
          <TrustBadge icon={<Package size={18} className="text-blue-600" data-id="element-127" />} text="Mercado Pago" data-id="element-126" />
          <TrustBadge icon={<Star size={18} className="text-yellow-500" data-id="element-129" />} text="4.9 Rating" data-id="element-128" />
          <TrustBadge icon={<MapPin size={18} className="text-blue-400" data-id="element-131" />} text="Todo Argentina" data-id="element-130" />
        </div>
      </div>
    </section>;
}
function Badge({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex items-center gap-2 bg-white/60 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-semibold text-dark border border-white/40" data-id="element-132">
      {icon}
      <span data-id="element-133">{text}</span>
    </div>;
}
function TrustBadge({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex items-center gap-1.5" data-id="element-134">
      {icon}
      <span data-id="element-135">{text}</span>
    </div>;
}